import { Trash2 } from "lucide-react";
import type { FC } from "react";
import type { UseFormReturn } from "react-hook-form";

import {
  CustomButton,
  type ItemWithId,
  LabelWithOptional,
} from "@/components/atoms";
import { InputControl, SelectControl } from "@/components/molecules";
import { commonIconProps20 } from "@/utils/constants";

import type { BrandContactsType } from "../types";

interface SocialMediaProps {
  form: UseFormReturn<BrandContactsType>;
  elem: object;
  index: number;
  onRemove: () => void;
  list: ItemWithId[];
}

const SocialMedia: FC<SocialMediaProps> = ({ form, index, onRemove, list }) => {
  return (
    <div className="flex items-start gap-3">
      <SelectControl
        label="Social profile"
        form={form}
        nameSelect={`socialLinks.${index}.type`}
        classes="flex-1"
        itemsList={list}
        placeholder="Select"
        triggerProps={{ "data-testid": `social-media-select-${index}` }}
      />

      <div className="flex items-center flex-2">
        <InputControl
          formControl={form.control}
          label={<LabelWithOptional label="Handle" />}
          nameField={`socialLinks.${index}.url`}
          classedName="mb-0 gap-2"
          data-testid={`social-media-input-${index}`}
        />
        <CustomButton
          variant="icon"
          className="self-end"
          onClick={onRemove}
          data-testid={`social-media-remove-${index}`}
        >
          <Trash2 {...commonIconProps20} />
        </CustomButton>
      </div>
    </div>
  );
};

export default SocialMedia;
